<template>
  <div :class="`designer-side ${!showActionView?'top0':''}`">
    <slot />
  </div>
</template>

<script>
import { mixin } from "./store";
export default {
  mixins: [mixin],
  props:{
    showActionView:{
      type: Boolean,
      default:true
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
